import { render } from "./permissionsMenu.vue?vue&type=template&id=f8fc5722"
import script from "./permissionsMenu.vue?vue&type=script&lang=js"
export * from "./permissionsMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__